/**
 * Viewport utilities for mobile devices
 *
 * Handles viewport meta tag optimization for Android virtual buttons
 * and other mobile-specific viewport issues
 */

export const optimizeViewportForMobile = () => {
  // Update or create viewport meta tag
  let viewportMeta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement;

  if (!viewportMeta) {
    viewportMeta = document.createElement('meta');
    viewportMeta.name = 'viewport';
    document.head.appendChild(viewportMeta);
  }

  // Optimized viewport settings for mobile web apps
  // viewport-fit=cover enables safe area support on iOS
  // interactive-widget=resizes-content handles virtual keyboard better
  // Removed user-scalable=no to allow native pull-to-refresh
  const viewportContent = [
    'width=device-width',
    'initial-scale=1.0',
    'viewport-fit=cover',
    'shrink-to-fit=no',
    'interactive-widget=resizes-content', // Better virtual keyboard handling
  ].join(', ');

  viewportMeta.content = viewportContent;

  // Add theme-color meta for better Android experience
  let themeColorMeta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement;
  if (!themeColorMeta) {
    themeColorMeta = document.createElement('meta');
    themeColorMeta.name = 'theme-color';
    // Brand twilight — must match the static <meta name="theme-color"> in
    // index.html, the PWA `theme_color` in public/manifest.json, and
    // `twilight[500]` in theme/colors.brand.ts (the brand.500 source).
    themeColorMeta.content = '#5C88DA';
    document.head.appendChild(themeColorMeta);
  }

  // Add apple-mobile-web-app-capable for better iOS PWA support
  let appleMeta = document.querySelector(
    'meta[name="apple-mobile-web-app-capable"]',
  ) as HTMLMetaElement;
  if (!appleMeta) {
    appleMeta = document.createElement('meta');
    appleMeta.name = 'apple-mobile-web-app-capable';
    appleMeta.content = 'yes';
    document.head.appendChild(appleMeta);
  }

  // Add apple-mobile-web-app-status-bar-style
  let appleStatusMeta = document.querySelector(
    'meta[name="apple-mobile-web-app-status-bar-style"]',
  ) as HTMLMetaElement;
  if (!appleStatusMeta) {
    appleStatusMeta = document.createElement('meta');
    appleStatusMeta.name = 'apple-mobile-web-app-status-bar-style';
    appleStatusMeta.content = 'default';
    document.head.appendChild(appleStatusMeta);
  }
};

export const preventOverscroll = () => {
  // Only prevent horizontal overscroll to stop left/right swipe gestures
  // Keep vertical overscroll enabled for native pull-to-refresh
  document.body.style.overscrollBehaviorX = 'none';
  document.documentElement.style.overscrollBehaviorX = 'none';

  // Explicitly allow vertical overscroll for pull-to-refresh
  document.body.style.overscrollBehaviorY = 'auto';
  document.documentElement.style.overscrollBehaviorY = 'auto';
};
